module.exports = __webpack_public_path__ + "img/hr-straight-rail-vertical-backplates-remnants.fa74a876.png";